<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 10/10/2020
  -->

<template>
    <div class="template-item-root">
        <el-card shadow="hover" :body-style="{ padding: '10px'}" style="cursor: pointer; padding: 14px;" class="fill-height row mx-0">
			<div><h5 class="card-title" style="font-weight: 600;">{{ program.name }}</h5></div>
<!--                <h6 class="card-subtitle" style="font-weight: 500;">{{ program.programTypeFormatted() }}</h6>-->
			<div class="layout-spacer"></div>
			<div>
				<small class="card-subtitle text-muted" style="font-weight: 500;">Created on {{ program.createdAtFormatted() }}</small>
			</div>
        </el-card>
    </div>
</template>

<script>

import CoachingProgram from "@shared/Program/CoachingProgram";


export default {
    name: "TemplateListItem",
    props: {
        program: {type: CoachingProgram},
        index: Number,
    },

    created() {
    },

    computed: {},


    methods: {},


}
</script>

<style lang="scss">
/**/
.template-item-root{
	.el-card__body{
		padding: 0;
		display: flex;
		flex-direction: column;
		flex: 1;
	}
}

</style>
